import { RestService } from "../communication-rest/communication-rest.service";
import { Injectable } from "@angular/core";
import { GenericResponse } from 'src/app/core/models/generic/generic.response';
import { ProcedureDto } from "../../models/configuration/procedures/procedure.dto";
import { urlServiceProducerKafka } from "../../constants/producer-kafka.constants";
import { ProcedureFilterDto } from "../../models/configuration/procedures/procedure-filters.dto";

@Injectable({
    providedIn: 'root'
})
export class CatProcedureService {    

    constructor(protected restService: RestService){
    }

    getProceduresByBranchOffId(branchOfficeId : number){
        return this.restService.get<GenericResponse>(urlServiceProducerKafka.catProcedures.allProcedures.replace('{branchOfficeId}', branchOfficeId.toString()))
    }

    getProceduresByFilters(procedure : ProcedureFilterDto, skipLoading?: boolean) {        
        return this.restService.post<GenericResponse>(urlServiceProducerKafka.catProcedures.proceduresByFilters, procedure, skipLoading)
    }

    saveProcedureFile(file : File, branchOfficeId : number, userId : string){
        return this.restService.postWithTokenFile<GenericResponse>(urlServiceProducerKafka.catProcedures.saveFile.replace('{userId}', userId.toString()).replace('{branchOfficeId}', branchOfficeId.toString()), file);
    }

    saveProcedure(procedure : ProcedureDto){
        return this.restService.post<GenericResponse>(urlServiceProducerKafka.catProcedures.saveProcedure, procedure)
    }

    updateProcedure(procedure : ProcedureDto){
        return this.restService.put<GenericResponse>(urlServiceProducerKafka.catProcedures.updateProcedure, procedure)
    }

    deleteProcedure(procedureId : number){
        return this.restService.delete<GenericResponse>(urlServiceProducerKafka.catProcedures.deleteProcedure.replace('{procedureId}', procedureId.toString()))
    }

    downloadProcedureErrors(uploadProcessId : number){
        return this.restService.getWithTokenFileDownload(urlServiceProducerKafka.catProcedures.downloadProcedureErrors.replace('{uploadProcessId}', uploadProcessId.toString()));
    }

    downloadTemplateProcedure(){
        return this.restService.getWithTokenFileDownload(urlServiceProducerKafka.catProcedures.downloadTemplateProcedure);
    }

    statusUploadProcess(uploadProcessId : number){
        return this.restService.get<GenericResponse>(urlServiceProducerKafka.catProcedures.statusUploadProcess.replace('{uploadProcessId}', uploadProcessId.toString()));
    }

    catalogSexType(){
        return this.restService.get<GenericResponse>(urlServiceProducerKafka.catProcedures.catalogSexType, true);
    }

    catalogClueAge(){
        return this.restService.get<GenericResponse>(urlServiceProducerKafka.catProcedures.catalogClueAge, true);
    }

    catalogProcedureType(){
        return this.restService.get<GenericResponse>(urlServiceProducerKafka.catProcedures.catalogProcedureType, true);
    }

    catalogProcedureUpdate(){
        return this.restService.get<GenericResponse>(urlServiceProducerKafka.catProcedures.catalogProcedureUpdate, true);
    }

}